import { render, staticRenderFns } from "./app-textarea.vue?vue&type=template&id=71667fa8&scoped=true&"
import script from "./app-textarea.vue?vue&type=script&lang=js&"
export * from "./app-textarea.vue?vue&type=script&lang=js&"
import style0 from "./app-textarea.vue?vue&type=style&index=0&id=71667fa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71667fa8",
  null
  
)

export default component.exports